import { Controller } from "@hotwired/stimulus"

const INTEREST_TAG_MAP = {
  kube: "calendrier-avent-2026-kube",
  nr:   "calendrier-avent-2026-new-romance",
  both: "calendrier-avent-2026-both"
}
const WAITLIST_TAG = "calendrier-avent-2026-waitlist"
const NEWSLETTER_TAGS = ["Chroniques", "OPTIN NL COMMERCIALES"]

export default class extends Controller {
  static targets = ["card", "picker", "pickerLabel", "form", "optin", "fine", "success"]

  selectOption(event) {
    const option = event.target.closest(".cdr-wl-option")
    if (!option) return

    this.pickerTarget.querySelectorAll(".cdr-wl-option").forEach((o) => o.classList.remove("selected"))
    option.classList.add("selected")

    const radio = option.querySelector("input[type='radio']")
    if (radio) radio.checked = true
  }

  submit(event) {
    event.preventDefault()

    const form = this.formTarget
    const firstName = form.querySelector("[name='first_name']").value.trim()
    const email = form.querySelector("[name='email']").value.trim()
    if (!firstName || !email) return

    const interest = this.#selectedInterest()
    const newsletter = this.cardTarget.querySelector("[name='newsletter']").checked
    const tags = [WAITLIST_TAG, INTEREST_TAG_MAP[interest] || INTEREST_TAG_MAP.both]
    if (newsletter) tags.push(...NEWSLETTER_TAGS)

    if (window._dcq) {
      window._dcq.push(["identify", { email, first_name: firstName, tags }])
    }

    this.#showSuccess()
  }

  #selectedInterest() {
    const checked = this.cardTarget.querySelector("[name='cdr-wl-interest']:checked")
    return checked ? checked.value : "both"
  }

  #showSuccess() {
    this.formTarget.style.display = "none"
    if (this.hasOptinTarget) this.optinTarget.style.display = "none"
    if (this.hasFineTarget) this.fineTarget.style.display = "none"
    if (this.hasPickerLabelTarget) this.pickerLabelTarget.style.display = "none"
    if (this.hasPickerTarget) this.pickerTarget.style.display = "none"
    if (this.hasSuccessTarget) this.successTarget.hidden = false
  }
}
